<template>
  <div>
    <div style="width:300px" class="mt-5">
      <v-autocomplete
        item-text="name"
        item-value="id"
        flat
        v-model="technician"
        solo
        hide-details
        :items="technicians"
        dense
      >
      </v-autocomplete>
    </div>
    <technician-item
      :details="details"
      v-for="(item, i) in items"
      :key="i"
      @onJobUpdate="onJobUpdate($event, i)"
      :date="date"
      :item="item"
    >
    </technician-item>
  </div>
</template>

<script>
import customerModal from "../../assets/js/customer.modal";
import TechnicianItem from "./TechnicianItem.vue";
export default {
  props: {
    jobs: Array,
    date: String,
    list: Array,
    details: Object
  },
  components: { TechnicianItem },
  data() {
    return {
      technician: "all"
    };
  },
  computed: {
    items: {
      get() {
        const vm = this;
        let unassigned = vm.jobs.filter(job => {
          let { total, reimbusements, charges, is_cheapo } = job;
          if (total == undefined) {
            job.total = job.fields[customerModal.TOTAL];
          }
          if (charges == undefined) charges = 0;
          if (is_cheapo == undefined) is_cheapo = false;
          // if (how_paid == undefined)
          job.how_paid = job.fields[customerModal.HOW_PAID];
          job.is_cheapo = is_cheapo;
          if (reimbusements == undefined) job.reimbusements = 0;
          return !job.technician;
        });
        let list = vm.$store.getters.technicians.map(item => {
          let name = item.name;
          item.technician_name = `${name} (${vm.getTechnicianType(item)})`;
          item.items = vm.jobs.filter(job => {
            let { total, how_paid, reimbusements, charges } = job;
            if (total == undefined) {
              job.total = job.fields[customerModal.TOTAL];
            }
            if (charges == undefined) charges = 0;
            if (how_paid == undefined)
              job.how_paid = job.fields[customerModal.HOW_PAID];
            if (reimbusements == undefined) job.reimbusements = 0;
            return job.technician == item.id;
          });
          let index = 0;
          item.items = item.items.map(item => {
            item.index = index;
            index++;
            return item;
          });
          let commission = vm.details.technician_commission;
          if (commission instanceof Object) {
            commission = commission[item.id];
          } else {
            commission = "";
          }
          item.total_commission = commission;
          return item;
        });
        list.unshift({
          technician_name: "Unassigned Jobs",
          items: unassigned
        });
        return list.filter(item => {
          let isCount = item.items.length != 0;
          let isAll = this.technician == "all" || this.technician == item.id;
          return isCount && isAll;
        });
      },
      set() {}
    },
    technicians() {
      let list = [{ name: "All Technicians", id: "all" }];
      this.$store.getters.technicians.forEach(item => {
        list.push(item);
      });
      return list;
    }
  },
  watch: {
    items() {
      this.$emit("input", this.items);
    }
  },
  methods: {
    onJobUpdate({ job }, i) {
      let item = this.items[i];
      console.log(item.items);
      let index = item.items.findIndex(item => {
        return item.id == job.id;
      });
      item.items[index] = job;
      this.$set(this.items, i, item);
      this.$emit("input", this.items);
    }
  }
};
</script>

<style></style>
